var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTriangleWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8217 18.7737L12.3227 0.801377C11.7588 -0.267125 10.2411 -0.267125 9.67577 0.801377L0.178232 18.7737C-0.354157 19.7817 0.370193 21 1.50246 21H20.499C21.6298 21 22.3541 19.7817 21.8217 18.7737ZM11 17.9731C10.1722 17.9731 9.5003 17.2951 9.5003 16.4596C9.5003 15.6242 10.1722 14.9462 11 14.9462C11.8278 14.9462 12.4997 15.6242 12.4997 16.4596C12.4997 17.2951 11.8278 17.9731 11 17.9731ZM12.4997 13.4327H9.5003V7.37887H12.4997V13.4327Z",
    fill: "#FFA150"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTriangleWarning);
export default __webpack_public_path__ + "static/media/icon-triangle-warning.14db9d85f34765b4e7f4f9b8d5117826.svg";
export { ForwardRef as ReactComponent };